// import Select from "react-select";
// import { useField, useFormikContext } from "formik";
// import { useEffect, useMemo, useRef, useState } from "react";
// import { clearInflight, getCachedPage, getInflight, setCachedPage, setInflight } from "utils/paginatedSelectCache";
// import { useParams } from "react-router-dom";

// const DEFAULT_LIMIT = 50;

// const PaginatedSelectField = ({
//     name,
//     placeholder = "Select...",
//     isMulti = false,
//     isDisabled = false,

//     /** Pagination */
//     limit = DEFAULT_LIMIT,

//     /** API hooks */
//     fetcher,        // (params) => Promise<{ data, total_pages }>
//     mapOption,      // (item) => ({ label, value })

//     /** Search */
//     searchable = true,
// }) => {
//     if (!fetcher) {
//         throw new Error("PaginatedSelectField: fetcher is required");
//     }

//     const { clientId } = useParams();
//     const shouldAutoLoadNextRef = useRef(false);

//     const { setFieldValue, setFieldTouched } = useFormikContext();
//     const [field, meta] = useField(name);

//     const [options, setOptions] = useState([]);
//     const [page, setPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [search, setSearch] = useState("");

//     const isFetchingRef = useRef(false);
//     const hasError = meta.touched && meta.error;

//     console.log("mapOption",mapOption);


//     //   const loadPage = async ({
//     //     pageNumber = 1,
//     //     searchText = "",
//     //     append = false,
//     //   }) => {
//     //     if (isFetchingRef.current) return;

//     //     isFetchingRef.current = true;
//     //     setLoading(true);

//     //     try {
//     //       const res = await fetcher({
//     //         page: pageNumber,
//     //         limit,
//     //         search: searchText,
//     //       });

//     //       console.log("res", res);

//     //       if(!res?.body?.data?.length) {
//     //         throw new Error("No client data");
//     //       }

//     //       const body = res.body;

//     //       const mapped = body.data.map(mapOption);

//     //       setOptions(prev => (append ? [...prev, ...mapped] : mapped));
//     //       setPage(pageNumber);
//     //       setTotalPages(body.total_pages || 1);
//     //     } catch(err) {
//     //         console.error("Error loading client list", err);
//     //     } finally {
//     //       isFetchingRef.current = false;
//     //       setLoading(false);
//     //     }
//     //   };

//     const loadPage = async ({
//         pageNumber = 1,
//         searchText = "",
//         append = false,
//     }) => {
//         const cacheKey = {
//             name,
//             page: pageNumber,
//             limit,
//             search: searchText,
//         };

//         // Serve from cache
//         const cached = getCachedPage(cacheKey);
//         // if (cached) {
//         //     setOptions(prev => (append ? [...prev, ...cached.options] : cached.options));
//         //     setPage(pageNumber);
//         //     setTotalPages(cached.totalPages);
//         //     return;
//         // } 

//         // // Deduplicate in-flight requests
//         // const inflightReq = getInflight(cacheKey);
//         // if (inflightReq) {
//         //     const cachedAfter = await inflightReq;
//         //     setOptions(prev =>
//         //         append ? [...prev, ...cachedAfter.options] : cachedAfter.options
//         //     );
//         //     setPage(pageNumber);
//         //     setTotalPages(cachedAfter.totalPages);
//         //     return;
//         // }

//         setLoading(true);

//         const promise = (async () => {
//             try {
//                 const res = await fetcher({
//                     page: pageNumber,
//                     limit,
//                     search: searchText,
//                 });

//                 const body = res?.body;
//                 if (!body?.data?.length) {
//                     throw new Error("No data");
//                 }

//                 const mapped = body.data.map(mapOption);

//                 const payload = {
//                     options: mapped,
//                     totalPages: body.total_pages || 1,
//                 };

//                 // setCachedPage(cacheKey, payload);

//                 return payload;
//             } finally {
//                 clearInflight(cacheKey);
//             }
//         })();

//         // setInflight(cacheKey, promise);

//         try {
//             const data = await promise;

//             setOptions(prev =>
//                 append ? [...prev, ...data.options] : data.options
//             );
//             setPage(pageNumber);
//             setTotalPages(data.totalPages);
//         } catch (err) {
//             console.error("Error loading data", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         loadPage({ pageNumber: 1 });
//     }, []);

//     useEffect(() => {
//         if (!shouldAutoLoadNextRef.current) return;
//         if (loading) return;
//         if (page >= totalPages) return;

//         // Allow DOM to paint
//         requestAnimationFrame(() => {
//             shouldAutoLoadNextRef.current = false;

//             loadPage({
//                 pageNumber: page + 1,
//                 searchText: search,
//                 append: true,
//             });
//         });
//     }, [options]);

//     const handleScrollBottom = () => {
//         if (loading) return;
//         if (page >= totalPages) return;

//         shouldAutoLoadNextRef.current = true;

//         loadPage({
//             pageNumber: page + 1,
//             searchText: search,
//             append: true,
//         });
//     };

//     const handleSearch = (value) => {
//         if (!searchable) return;

//         setSearch(value);
//         loadPage({
//             pageNumber: 1,
//             searchText: value,
//             append: false,
//         });
//     };

//     return (
//         <>
//             <Select
//                 inputId={name}
//                 name={name}
//                 placeholder={placeholder}
//                 isMulti={isMulti}
//                 isDisabled={isDisabled}
//                 isLoading={loading}
//                 options={options}
//                 onMenuScrollToBottom={handleScrollBottom}
//                 onInputChange={handleSearch}
//                 value={
//                     isMulti
//                         ? options.filter(o => field.value?.includes(o.value))
//                         : options.find(o => o.value === field.value) || null
//                 }
//                 onChange={(selected) => {
//                     if (isMulti) {
//                         setFieldValue(
//                             name,
//                             selected ? selected.map(o => o.value) : []
//                         );
//                     } else {
//                         setFieldValue(name, selected ? selected.value : "");
//                     }
//                 }}
//                 onBlur={() => setFieldTouched(name, true)}
//                 classNamePrefix="react-select"
//                 className={hasError ? "is-invalid" : ""}
//                 styles={bootstrapSelectStyles(hasError)}
//             />

//             {hasError && (
//                 <div className="invalid-feedback d-block">
//                     {meta.error}
//                 </div>
//             )}
//         </>
//     );
// };

// const bootstrapSelectStyles = (hasError) => ({
//     control: (base, state) => ({
//         ...base,
//         minHeight: "38px",
//         borderRadius: "0.375rem",
//         borderColor: hasError
//             ? "#dc3545"
//             : state.isFocused
//                 ? "#86b7fe"
//                 : "#ced4da",
//         boxShadow: state.isFocused
//             ? "0 0 0 0.25rem rgba(13,110,253,.25)"
//             : "none",
//         "&:hover": {
//             borderColor: state.isFocused
//                 ? "#86b7fe"
//                 : "#ced4da",
//         },
//     }),
//     valueContainer: (base) => ({
//         ...base,
//         padding: "0.375rem 0.75rem",
//     }),
//     input: (base) => ({
//         ...base,
//         margin: 0,
//         padding: 0,
//     }),
//     indicatorsContainer: (base) => ({
//         ...base,
//         height: "38px",
//     }),
//     menu: (base) => ({
//         ...base,
//         zIndex: 9999,
//     }),
//     option: (base, state) => ({
//         ...base,
//         backgroundColor: state.isSelected
//             ? "#0d6efd"
//             : state.isFocused
//                 ? "#e9ecef"
//                 : "white",
//         color: state.isSelected ? "white" : "#212529",
//     }),
// });

// export default PaginatedSelectField;


import Select from "react-select";
import { useField, useFormikContext } from "formik";
import { useEffect, useMemo, useRef, useState } from "react";
import { clearInflight, getCachedPage, getInflight, setCachedPage, setInflight, getAllCachedPages } from "utils/paginatedSelectCache";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";


const DEFAULT_LIMIT = 50;

const PaginatedSelectField = ({
    name,
    placeholder = "Select...",
    isMulti = false,
    isDisabled = false,

    /** Pagination */
    limit = DEFAULT_LIMIT,

    /** API hooks */
    fetcher,        // (params) => Promise<{ data, total_pages }>
    mapOption,      // (item) => ({ label, value })

    /** Search */
    searchable = true,
}) => {
    if (!fetcher) {
        throw new Error("PaginatedSelectField: fetcher is required");
    }

    const { clientId } = useParams();
    const shouldAutoLoadNextRef = useRef(false);

    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(name);

    const [options, setOptions] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const isFetchingRef = useRef(false);
    const hasError = meta.touched && meta.error;

    // Track if we've already loaded cached data
    const hasLoadedCachedDataRef = useRef(false);

    const loadPage = async ({
        pageNumber = 1,
        searchText = "",
        append = false,
    }) => {
        const cacheKey = {
            name,
            page: pageNumber,
            limit,
            search: searchText,
        };

        // Serve from cache
        const cached = getCachedPage(cacheKey);
        if (cached) {
            setOptions(prev => (append ? [...prev, ...cached.options] : cached.options));
            setPage(pageNumber);
            setTotalPages(cached.totalPages);
            return;
        }

        // Deduplicate in-flight requests
        const inflightReq = getInflight(cacheKey);
        if (inflightReq) {
            const cachedAfter = await inflightReq;
            setOptions(prev =>
                append ? [...prev, ...cachedAfter.options] : cachedAfter.options
            );
            setPage(pageNumber);
            setTotalPages(cachedAfter.totalPages);
            return;
        }

        setLoading(true);

        const promise = (async () => {
            try {
                const res = await fetcher({
                    page: pageNumber,
                    limit,
                    search: searchText,
                });

                const body = res?.body;
                if (!body?.data?.length) {
                    throw new Error("No data");
                }

                const mapped = body.data.map(mapOption);

                const payload = {
                    options: mapped,
                    totalPages: body.total_pages || 1,
                };

                setCachedPage(cacheKey, payload);

                return payload;
            } finally {
                clearInflight(cacheKey);
            }
        })();

        setInflight(cacheKey, promise);

        try {
            const data = await promise;

            setOptions(prev =>
                append ? [...prev, ...data.options] : data.options
            );
            setPage(pageNumber);
            setTotalPages(data.totalPages);
        } catch (err) {
            console.error("Error loading data", err);
        } finally {
            setLoading(false);
        }
    };

    // Function to load all cached data at once
    const loadAllCachedData = (searchText = "") => {
        // Get all cached pages for this search term
        const allCachedPages = getAllCachedPages(name, limit, searchText);

        if (allCachedPages.length === 0) {
            return false; // No cached data available
        }

        // Sort pages by page number
        const sortedPages = allCachedPages.sort((a, b) => a.page - b.page);

        // Combine all options from cached pages
        let allOptions = [];
        let maxPage = 1;
        let totalPagesFromCache = 1;

        sortedPages.forEach(cachedPage => {
            allOptions.push(...cachedPage.options);
            maxPage = Math.max(maxPage, cachedPage.page);
            totalPagesFromCache = cachedPage.totalPages;
        });

        // Remove duplicates
        const uniqueOptions = removeDuplicates(allOptions, 'value');

        setOptions(uniqueOptions);
        setPage(maxPage);
        setTotalPages(totalPagesFromCache);
        hasLoadedCachedDataRef.current = true;

        return true; // Successfully loaded cached data
    };

    // Helper function to remove duplicates
    const removeDuplicates = (array, key) => {
        const seen = new Set();
        return array.filter(item => {
            const value = item[key];
            if (seen.has(value)) {
                return false;
            }
            seen.add(value);
            return true;
        });
    };

    useEffect(() => {
        // Try to load cached data first
        const hasCachedData = loadAllCachedData("");

        // If no cached data, load page 1 from API
        if (!hasCachedData) {
            loadPage({ pageNumber: 1 });
        }
    }, []);

    useEffect(() => {
        if (!shouldAutoLoadNextRef.current) return;
        if (loading) return;
        if (page >= totalPages) return;

        // Allow DOM to paint
        requestAnimationFrame(() => {
            shouldAutoLoadNextRef.current = false;

            loadPage({
                pageNumber: page + 1,
                searchText: search,
                append: true,
            });
        });
    }, [options]);

    const handleScrollBottom = () => {
        if (loading) return;
        if (page >= totalPages) return;

        shouldAutoLoadNextRef.current = true;

        loadPage({
            pageNumber: page + 1,
            searchText: search,
            append: true,
        });
    };

    const handleSearch = debounce((value) => {
        if (!searchable) return;

        // Reset cached data flag on search
        hasLoadedCachedDataRef.current = false;

        setSearch(value);

        // Try to load cached data for this search
        const hasCachedData = loadAllCachedData(value);

        // If no cached data for this search, load from API
        if (!hasCachedData) {
            loadPage({
                pageNumber: 1,
                searchText: value,
                append: false,
            });
        }
    }, 400)

    return (
        <>
            <Select
                inputId={name}
                name={name}
                placeholder={placeholder}
                isMulti={isMulti}
                isDisabled={isDisabled}
                isLoading={loading}
                options={options}
                onMenuScrollToBottom={handleScrollBottom}
                onInputChange={handleSearch}
                value={
                    isMulti
                        ? options.filter(o => field.value?.includes(o.value))
                        : options.find(o => o.value === field.value) || null
                }
                onChange={(selected) => {
                    if (isMulti) {
                        setFieldValue(
                            name,
                            selected ? selected.map(o => o.value) : []
                        );
                    } else {
                        setFieldValue(name, selected ? selected.value : "");
                    }
                }}
                onBlur={() => setFieldTouched(name, true)}
                classNamePrefix="react-select"
                className={hasError ? "is-invalid" : ""}
                styles={bootstrapSelectStyles(hasError)}
                onMenuOpen={() => {
                    // When dropdown opens, try to load cached data if not already loaded
                    if (!hasLoadedCachedDataRef.current && !loading) {
                        const hasCachedData = loadAllCachedData(search);
                        if (!hasCachedData && options.length === 0) {
                            loadPage({ pageNumber: 1, searchText: search });
                        }
                    }
                }}
            />

            {hasError && (
                <div className="invalid-feedback d-block">
                    {meta.error}
                </div>
            )}
        </>
    );
};

const bootstrapSelectStyles = (hasError) => ({
    control: (base, state) => ({
        ...base,
        minHeight: "38px",
        borderRadius: "0.375rem",
        borderColor: hasError
            ? "#dc3545"
            : state.isFocused
                ? "#86b7fe"
                : "#ced4da",
        boxShadow: state.isFocused
            ? "0 0 0 0.25rem rgba(13,110,253,.25)"
            : "none",
        "&:hover": {
            borderColor: state.isFocused
                ? "#86b7fe"
                : "#ced4da",
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0.375rem 0.75rem",
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "38px",
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? "#0d6efd"
            : state.isFocused
                ? "#e9ecef"
                : "white",
        color: state.isSelected ? "white" : "#212529",
    }),
});

export default PaginatedSelectField;